import React, { PureComponent } from 'react';
import styles from '../styles/style.module.css';

import sliderPrev from 'appSrc/assets/img/left-chev-purple.svg';

export default class LeftControl extends PureComponent {
    render() {
        const { style, onClick, className, extendedClass } = this.props;
        var disabled = className.includes( 'slick-disabled' );
        return (
            <div className={ `${ styles.leftControl } ${ extendedClass }` }
            style={ { ...style, display: ( disabled ? 'none' : 'block' ) } }
            onClick={ onClick }>
                <img src={ sliderPrev } />
            </div>
        );
    }
}
LeftControl.defaultProps = {
    className: '',
    extendedClass: '',
};
